import httpClient from "../../../shared/api/httpClient";

// Corpo de POST e PATCH: o modal sempre manda todos os campos. Hora e duração só valem em
// evento de um dia; fora disso vão vazias (hora_inicio "" remove a hora no PATCH).
function toBody({ tipo, titulo, dataInicio, dataFim, horaInicio, horas, observacao }) {
  const comHora = tipo === "evento" && (!dataFim || dataFim === dataInicio) && Boolean(horaInicio);
  return {
    tipo,
    titulo: titulo ?? "",
    data_inicio: dataInicio,
    data_fim: dataFim || dataInicio,
    hora_inicio: comHora ? horaInicio : "",
    horas: comHora ? Number(horas) : 0,
    observacao: observacao ?? "",
  };
}

// Compromissos (folga, férias, feriado, evento) — /api/v1/compromissos.
export const calendarEventsApi = {
  list: ({ de, ate }) =>
    httpClient.get(`/api/v1/compromissos?de=${de}&ate=${ate}`).then((r) => r.data.dados ?? []),

  create: (values) => httpClient.post("/api/v1/compromissos", toBody(values)).then((r) => r.data.dados),

  update: ({ id, ...values }) => httpClient.patch(`/api/v1/compromissos/${id}`, toBody(values)).then((r) => r.data.dados),

  remove: (id) => httpClient.delete(`/api/v1/compromissos/${id}`).then((r) => r.data),
};
